<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path class="strokeDefault strokeActive" d="M1 10.0693H18" stroke="#21242A" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
<path class="strokeDefault strokeActive" d="M12 16.0693L18 10.0693L12 4.06934" stroke="#21242A" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
